import {ArrowRight} from 'lucide-react';
import {memo, ReactElement} from 'react';
import RepoCard from './RepoCard';
import {Repository} from 'types';

type SectionProps = {
  title: string;
  subtitle: string | ReactElement;
  repos: Repository[];
  scrollHint?: boolean;
};

function ProjectRepoGrid({title, subtitle, repos, scrollHint = false}: SectionProps): ReactElement {
  return (
    <div className="projects-section-root">
      <div className="section-head">
        <div className="section-title-row">
          <h2 className="section-title">{title}</h2>
        </div>
        <p className="section-subtitle">{subtitle}</p>
      </div>
      <div className="section-content-shell">
        <div className="section-content">
          <div className="section-repos">
            {repos.map((repo) => <RepoCard key={repo.id} repo={repo} />)}
          </div>
        </div>
        {scrollHint && (
          <span className="project-scroll-hint" aria-hidden="true">
            <span className="project-scroll-cue">
              <ArrowRight />
            </span>
          </span>
        )}
      </div>
    </div>
  );
}

export const ProjectsSection = memo(ProjectRepoGrid);
